import { Empty } from "antd";
import { getTagHierarchy } from "../../model/reportService";
import { Body, Title } from "@vds/typography";
import SearchInput from "../../global/utility/Utils";
import { DropdownSelect } from "@vds/selects";
import { USER_GROUP_DETAILS_CONSTANTS, TABLE_COLUMNS } from "../../global/constants/constants";
import "./UserGroupsModals.css";
import {
  Cell,
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "@vds/tables";
import { Button } from "@vds/buttons";
import { Input } from "@vds/inputs";
import { Checkbox } from "@vds/checkboxes";
import { Spinner } from "react-bootstrap";

export const siteReducer = (accumulator, currentState, stateName) => {
  console.log("currentState", currentState);
  if (currentState.kind === "ts.tag.state") {
    stateName = currentState.name;
    const traverse = (tags, subtitle) => {
      tags.forEach((tag) => {
        if (tag.kind === "ts.tag.site") {
          accumulator.push({
            id: tag.id,
            title: tag.name,
            subtitle: subtitle ? `${subtitle}, ${stateName}` : tag.name,
            checked: false,
          });
        } else if (tag.nestedtags && tag.nestedtags.length > 0) {
          traverse(
            tag.nestedtags,
            `${subtitle ? subtitle + ", " : ""}${tag.name}`
          );
        }
      });
    };

    traverse(currentState.nestedtags, "");
  }
  return accumulator;
};

export const fetchSiteList = async (setSiteList) => {
  try {
    const options = {
      maxdepth: 4,
    };
    const resourceidentifier = {
      id: "cd41f641-30a6-66aa-e2aa-a080f20f7079",
    };
    const response = await getTagHierarchy(options, resourceidentifier);

    const siteTitles = response.reduce(siteReducer, []);
    setSiteList(siteTitles);
  } catch (error) {
    console.error("Error fetching site list:", error);
  }
};

export const renderStepTwoContent = ({
  groupName,
  setGroupName,
  errorMessage,
  handleBack,
  handleNext,
  handleGroupNameChange,
  isValid,
  title,
}) => (
  <>
    <Title bold={true} size="medium">
      {title}
    </Title>
    <div className="step-name-group-wrapper">
      <Input
        type="text"
        label={USER_GROUP_DETAILS_CONSTANTS.LABEL_GROUP_NAME}
        value={groupName}
        onChange={(e) => handleGroupNameChange(e)}
        readOnly={false}
        required={true}
        disabled={false}
        error={errorMessage !== ""}
        errorText={errorMessage}
      />
    </div>
    <div className="step-button-row">
      <Button
        size="medium"
        disabled={false}
        data-testid="addGroupsModal_stepTwoBackButton"
        onClick={handleBack}
        width="48%"
        use="secondary"
      >
        {USER_GROUP_DETAILS_CONSTANTS.BUTTON_BACK}
      </Button>
      <Button
        size="medium"
        width="48%"
        disabled={!isValid || groupName.trim() === ""}
        data-testid="addGroupsModal_stepTwonextButton"
        onClick={handleNext}
        use="primary"
      >
        {USER_GROUP_DETAILS_CONSTANTS.BUTTON_NEXT}
      </Button>
    </div>
  </>
);

export const renderStepOneContent = ({
  filteredSites,
  selectedSiteName,
  handleSiteToggle,
  isValid,
  handleBack,
  handleNext,
  title,
  body,
}) => (
  <>
    <Title bold={true} size="medium">
      {title}
    </Title>
    <div className="step-site-dropdown-wrapper">
      <Body size="medium">{body}</Body>
    </div>

    <div className="step-site-button-row">
      <DropdownSelect
        label={USER_GROUP_DETAILS_CONSTANTS.LABEL_SITE}
        value={selectedSiteName || ""}
        onChange={(e) => handleSiteToggle(e.target.value, filteredSites)}
        onInvalid={(e) => e.preventDefault()}
        error={false}
      >
        <option value="">{USER_GROUP_DETAILS_CONSTANTS.TEXT_SELECT_A_SITE}</option>
        {filteredSites?.length > 0 && Array.isArray(filteredSites) ? (
          filteredSites?.map((site) => (
            <option key={site.id} value={site.id}>
              {site?.title || site?.name}
            </option>
          ))
        ) : (
          <option value="">{USER_GROUP_DETAILS_CONSTANTS.TEXT_NO_SITES_AVAILABLE}</option>
        )}
      </DropdownSelect>
    </div>

    <div className="step-button-row-spaced">
      <Button
        size="medium"
        width="48%"
        disabled={false}
        use="secondary"
        data-testid="addGroupsModal_stepOneCancelButton"
        onClick={handleBack}
      >
        {USER_GROUP_DETAILS_CONSTANTS.BUTTON_CANCEL}
      </Button>
      <Button
        size="medium"
        width="48%"
        use="primary"
        data-testid="addGroupsModal_stepOneNextButton"
        onClick={handleNext}
        disabled={!isValid}
      >
        {USER_GROUP_DETAILS_CONSTANTS.BUTTON_NEXT}
      </Button>
    </div>
  </>
);

export const renderStepThreeContent = ({
  userData,
  selectedMembers,
  handleCheckboxChange,
  handleBack,
  handleNext,
  title,
  searchQuery,
  handleSearchChange,
  body,
  newSelectedMembers,
  setNewSelectedMembers,
  page,
  loading,
}) => {
  const isUserSelected = (userId) =>
    Array.isArray(selectedMembers) &&
    selectedMembers.some((selectedUser) => selectedUser.id === userId);
  const handleNewCheckboxChange = (user) => {
    setNewSelectedMembers((prev) => {
      const isAlreadySelected = prev.some((member) => member.id === user.id);
      if (isAlreadySelected) {
        return prev.filter((member) => member.id !== user.id);
      } else {
        return [...prev, user];
      }
    });
    handleCheckboxChange(user);
  };

  const isAddMembersButtonEnabled = newSelectedMembers?.length > 0;

  console.log(userData, "userData");
  return (
    <div className="step-three-container">
      <div className="step-three-header">
        <Title bold={true} size="medium">
          {title}
        </Title>
        <div className="step-three-search-wrapper">
          <SearchInput
            value={searchQuery}
            onChange={handleSearchChange}
            placeholder={USER_GROUP_DETAILS_CONSTANTS.SEARCH_USERS_PLACEHOLDER}
          />
        </div>
      </div>
      <div className="step-three-body-text">
        <Body size="medium">{body}</Body>
      </div>
      <div className="step-three-table-wrapper">
        <Table striped={false} surface="light" padding="compact">
          <TableHead>
            <TableHeader>{USER_GROUP_DETAILS_CONSTANTS.TABLE_HEADER_USER_NAME}</TableHeader>
            <TableHeader>{TABLE_COLUMNS.EMAIL}</TableHeader>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <Cell colSpan={2}>
                  <div className="step-three-loading">
                    <Spinner animation="border" variant="dark" />
                  </div>
                </Cell>
              </TableRow>
            ) : userData?.length > 0 ? (
              userData?.map((user) => (
                <TableRow key={user.id}>
                  <Cell>
                    <Checkbox
                      selected={
                        isUserSelected(user.id) ||
                        newSelectedMembers?.some(
                          (member) => member.id === user.id
                        )
                      }
                      disabled={
                        isUserSelected(user.id) && page !== USER_GROUP_DETAILS_CONSTANTS.PAGE_ADD_GROUP_MODAL
                      }
                      onChange={() => handleNewCheckboxChange(user)}
                    >
                      {`${user.firstname || ""} ${user.lastname || ""}`}
                    </Checkbox>
                  </Cell>
                  <Cell className="add-members-email-cell">{user.email || ""}</Cell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <Cell colSpan={2}>
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No data" />
                </Cell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
      <div className="step-three-button-row">
        <Button
          size="medium"
          disabled={false}
          use="secondary"
          className="add-members-btn"
          data-testid="addGroupsModal_stepThreeBackButton"
          onClick={handleBack}
        >
          {USER_GROUP_DETAILS_CONSTANTS.BUTTON_BACK}
        </Button>
        <Button
          size="medium"
          disabled={!isAddMembersButtonEnabled}
          use="primary"
          className="add-members-btn"
          data-testid="addGroupsModal_stepThreeAddMembersButton"
          onClick={handleNext}
        >
          {USER_GROUP_DETAILS_CONSTANTS.ADD_MEMBERS}
        </Button>
      </div>
    </div>
  );
};

export const renderStepFourContent = ({
  handleBack,
  handleNext,
  title,
  groupName,
  checkedSites = [],
  selectedMembers = [],
  siteTagList,
}) => {
  const SitesTagList = siteTagList;
  const sitename =
    checkedSites.length > 0
      ? SitesTagList.sites.find(
          (site) => site.id === checkedSites[checkedSites.length - 1]
        )?.name
      : undefined;

  return (
    <>
      <Title bold={true} size="medium">
        {title}
      </Title>
      <div className="step-four-site-input">
        <Input
          type="text"
          label={USER_GROUP_DETAILS_CONSTANTS.LABEL_SITE}
          value={sitename}
          readOnly
        />
      </div>
      <div className="step-four-group-input">
        <Input
          type="text"
          label={USER_GROUP_DETAILS_CONSTANTS.LABEL_GROUP_NAME}
          value={groupName}
          readOnly
        />
      </div>
      <div className="step-four-members-section">
        <p className="step-four-members-label">{USER_GROUP_DETAILS_CONSTANTS.LABEL_GROUP_MEMBERS}</p>
        {selectedMembers?.length > 0 ? (
          selectedMembers
            .map((member) => member.firstname + " " + member.lastname)
            .join(", ")
        ) : (
          <p>{USER_GROUP_DETAILS_CONSTANTS.TEXT_NO_MEMBERS_SELECTED}</p>
        )}
      </div>
      <div className="step-four-button-row">
        <Button
          size="medium"
          disabled={false}
          width="225px"
          use="secondary"
          data-testid="addGroupsModal_stepFourBackButton"
          onClick={handleBack}
        >
          {USER_GROUP_DETAILS_CONSTANTS.BUTTON_BACK}
        </Button>
        <Button
          size="medium"
          width="225px"
          data-testid="addGroupsModal_stepFourSubmitButton"
          onClick={handleNext}
          use="primary"
        >
          {USER_GROUP_DETAILS_CONSTANTS.BUTTON_SUBMIT}
        </Button>
      </div>
    </>
  );
};
